 <template>
  <div class="bg">
  	  <img src="@assets/images/ecards.png" />
  	  <div class="forms">
       <div style="text-align: center;margin-bottom: 50px">
         <p style="width:50%;float:left">账号：{{account}}</p>
        <p style="width:50%;float:left">密码：<span style="background: #333">{{pwd}}</span></p>
       </div>
  	   <img src="@assets/images/sub.png"  @click="pushNext" />
  	  </div>
  </div>
</template>
<script>
import { getUser , getConvert } from "@api/user";



export default {  
   data: function() {
    return {
     
      	cards:'',
        account:'',
        pwd:'',
        uid:'',
         msg:''
    };
  },
  mounted: function() {
    this.User();
    this.convert();
  },
  methods: {
  	convert(){
       let that = this;
       that.cards = this.$route.query.card;
       console.log(that.cards)
  		let headers = {
	     	'content-type': 'application/x-www-form-urlencoded'
	    }
 
  	    let url = 'http://www.fangyangwang.cn/ecash_backend//getvcard?cardsn='+that.cards
        if( that.cards){
           that.$axios({
           header:headers,
                method:'get',
                datatype:'json',
                url:url,
            }).then((data) =>{          //这里使用了ES6的语法
                let that = this
                console.log(data.data)       //请求成功返回的数据
                that.account = data.data.s
                that.pwd = data.data.p
            }).catch((res) =>{
                console.log(res.response)
                that.$dialog.toast({ mes: '无效的电子卡' });
            }) 	
          }else{
            that.$dialog.toast({ mes: '无效的电子卡' });
          }    
  	},
    User: function() {
      let that = this;
      getUser().then(res => {
          console.log(res)
          that.uid = res.data.uid;
      });
    },
    pushNext:function(){
      let that = this;
      let headers = {
    'content-type': 'application/x-www-form-urlencoded'
      }
      
      let url = 'http://www.fangyangwang.cn/ecash_backend/chequecard'
      let param = new FormData()
      param.append('cardsn', that.account)
      param.append('pwd', that.pwd)
      param.append('uid', that.uid)
      
      that.$axios({
          header:headers,
                method:'post',
                url:url,
                data:param
            }).then((response) =>{          //这里使用了ES6的语法
                console.log(response)       //请求成功返回的数据
                
                if(response.status==200){
                  that.msg = '兑换成功，请查收余额';
                  that.$dialog.toast({ mes: that.msg });
                }
            }).catch((error) =>{
                console.log(error.response)       //请求失败返回的数据
                if(error.response.data.code == 422){
                  that.msg = error.response.data.msg;
                }else{
                  that.msg = '系统错误，请稍后重试';
                }
                that.$dialog.toast({ mes: that.msg });
            })

      // this.$router.push({
      //   path:'/user/UserCards',
      //   query:{
      //     account:that.account,
      //     psd:that.pwd
      //   }
      // })
      
    }

  }  
};
</script>
<style
 scoped>
.bg{
	height: 100%;
	width: 100%;
	position: relative;
}
.bg img{
	display: block;
	width: 100%;
	height: 100%;
}
.forms{
	position: absolute;
	top:65%;
	width: 80%;
    margin:0 auto;
    left:0;
    right: 0;
}
.forms input{
	display: block;
	background: white;
	margin:30px auto;
	width: 100%;
	height: 40px;
	border-radius: 18px;
	padding-left: 15px;
	font-size: 18px;
}
.ilbox{
  background:rgba(0,0,0,0.5);
  padding:20px;
}
</style>